/* languages from http://momentjs.com */
export const LOCALES = {
    "en": {
        month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_names_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        day_names_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        date_suffix: function (date) {
            var day10 = ~~(date % 100 / 10);
            var day1 = date % 10;
            if (day10 === 1) {
                return "th";
            } else if (day1 === 1) {
                return "st";
            } else if (day1 === 2) {
                return "nd";
            } else if (day1 === 3) {
                return "rd";
            } else {
                return "th";
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return isLower ? "am" : "AM";
            } else {
                return isLower ? "pm" : "PM";
            }
        }
    },
    "en-us": {
        month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_names_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        day_names_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        date_suffix: function (date) {
            var day10 = ~~(date % 100 / 10);
            var day1 = date % 10;
            if (day10 === 1) {
                return "th";
            } else if (day1 === 1) {
                return "st";
            } else if (day1 === 2) {
                return "nd";
            } else if (day1 === 3) {
                return "rd";
            } else {
                return "th";
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return isLower ? "am" : "AM";
            } else {
                return isLower ? "pm" : "PM";
            }
        }
    },
    "ar-ma": {
        month_names: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        month_names_short: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        day_names: "الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        day_names_short: "احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ar": {
        month_names: "يناير/ كانون الثاني_فبراير/ شباط_مارس/ آذار_أبريل/ نيسان_مايو/ أيار_يونيو/ حزيران_يوليو/ تموز_أغسطس/ آب_سبتمبر/ أيلول_أكتوبر/ تشرين الأول_نوفمبر/ تشرين الثاني_ديسمبر/ كانون الأول".split("_"),
        month_names_short: "يناير/ كانون الثاني_فبراير/ شباط_مارس/ آذار_أبريل/ نيسان_مايو/ أيار_يونيو/ حزيران_يوليو/ تموز_أغسطس/ آب_سبتمبر/ أيلول_أكتوبر/ تشرين الأول_نوفمبر/ تشرين الثاني_ديسمبر/ كانون الأول".split("_"),
        day_names: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        day_names_short: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "bg": {
        month_names: "януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),
        month_names_short: "янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),
        day_names: "неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),
        day_names_short: "нед_пон_вто_сря_чет_пет_съб".split("_"),
        date_suffix: function (date) {
            var lastDigit = date % 10,
                last2Digits = date % 100;
            if (date === 0) {
                return '-ев';
            } else if (last2Digits === 0) {
                return '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return '-ти';
            } else if (lastDigit === 1) {
                return '-ви';
            } else if (lastDigit === 2) {
                return '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return '-ми';
            } else {
                return '-ти';
            }
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "br": {
        month_names: "Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
        month_names_short: "Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
        day_names: "Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn".split("_"),
        day_names_short: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
        date_suffix: function (date) {
            return (date === 1) ? 'añ' : 'vet';
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "bs": {
        month_names: "januar_februar_mart_april_maj_juni_juli_avgust_septembar_oktobar_novembar_decembar".split("_"),
        month_names_short: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
        day_names: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
        day_names_short: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ca": {
        month_names: "gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),
        month_names_short: "gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.".split("_"),
        day_names: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
        day_names_short: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
        date_suffix: function (date) {
            return "º";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "cs": {
        month_names: "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),
        month_names_short: "led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),
        day_names: "neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),
        day_names_short: "ne_po_út_st_čt_pá_so".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "cv": {
        month_names: "кăрлач_нарăс_пуш_ака_май_çĕртме_утă_çурла_авăн_юпа_чӳк_раштав".split("_"),
        month_names_short: "кăр_нар_пуш_ака_май_çĕр_утă_çур_ав_юпа_чӳк_раш".split("_"),
        day_names: "вырсарникун_тунтикун_ытларикун_юнкун_кĕçнерникун_эрнекун_шăматкун".split("_"),
        day_names_short: "выр_тун_ытл_юн_кĕç_эрн_шăм".split("_"),
        date_suffix: function (date) {
            return "-мĕш";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "cy": {
        month_names: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
        month_names_short: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
        day_names: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
        day_names_short: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
        date_suffix: function (date) {
            var b = date,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];

            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }

            return output;
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "da": {
        month_names: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
        month_names_short: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        day_names: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
        day_names_short: "søn_man_tir_ons_tor_fre_lør".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "de": {
        month_names: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        month_names_short: "Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
        day_names: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        day_names_short: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "el": {
        month_names: "Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),
        month_names_short: "Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),
        day_names: "Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),
        day_names_short: "Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),
        date_suffix: function (date) {
            return "η";
        },
        meridiem: function (hour, minute, isLower) {
            if (hour > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        }
    },
    "en-au": {
        month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_names_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        day_names_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        date_suffix: function (date) {
            var day10 = ~~(date % 100 / 10);
            var day1 = date % 10;
            if (day10 === 1) {
                return "th";
            } else if (day1 === 1) {
                return "st";
            } else if (day1 === 2) {
                return "nd";
            } else if (day1 === 3) {
                return "rd";
            } else {
                return "th";
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return isLower ? "am" : "AM";
            } else {
                return isLower ? "pm" : "PM";
            }
        }
    },
    "en-ca": {
        month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_names_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        day_names_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        date_suffix: function (date) {
            var day10 = ~~(date % 100 / 10);
            var day1 = date % 10;
            if (day10 === 1) {
                return "th";
            } else if (day1 === 1) {
                return "st";
            } else if (day1 === 2) {
                return "nd";
            } else if (day1 === 3) {
                return "rd";
            } else {
                return "th";
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return isLower ? "am" : "AM";
            } else {
                return isLower ? "pm" : "PM";
            }
        }
    },
    "en-gb": {
        month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_names_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        day_names_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        date_suffix: function (date) {
            var day10 = ~~(date % 100 / 10);
            var day1 = date % 10;
            if (day10 === 1) {
                return "th";
            } else if (day1 === 1) {
                return "st";
            } else if (day1 === 2) {
                return "nd";
            } else if (day1 === 3) {
                return "rd";
            } else {
                return "th";
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return isLower ? "am" : "AM";
            } else {
                return isLower ? "pm" : "PM";
            }
        }
    },
    "eo": {
        month_names: "januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),
        month_names_short: "jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec".split("_"),
        day_names: "Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato".split("_"),
        day_names_short: "Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab".split("_"),
        date_suffix: function (date) {
            return "a";
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            } else {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            }
        }
    },
    "es": {
        month_names: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        month_names_short: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        day_names: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
        day_names_short: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
        date_suffix: function (date) {
            return "º";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "et": {
        month_names: "jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),
        month_names_short: "jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
        day_names: "pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),
        day_names_short: "P_E_T_K_N_R_L".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "eu": {
        month_names: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),
        month_names_short: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
        day_names: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
        day_names_short: "ig._al._ar._az._og._ol._lr.".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "fa": {
        month_names: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        month_names_short: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        day_names: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        day_names_short: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return "قبل از ظهر";
            } else {
                return "بعد از ظهر";
            }
        },
        date_suffix: function (date) {
            return 'م';
        }
    },
    "fi": {
        month_names: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),
        month_names_short: "tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),
        day_names: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
        day_names_short: "su_ma_ti_ke_to_pe_la".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "fo": {
        month_names: "januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        month_names_short: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        day_names: "sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),
        day_names_short: "sun_mán_týs_mik_hós_frí_ley".split("_"),
        date_suffix: function () {
            return '.';
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "fr-ca": {
        month_names: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        month_names_short: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        day_names: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        day_names_short: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        date_suffix: function (date) {
            return (date === 1 ? 'er' : '');
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "fr": {
        month_names: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        month_names_short: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        day_names: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        day_names_short: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        date_suffix: function (date) {
            return (date === 1 ? 'er' : '');
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "fr-fr": {
        month_names: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        month_names_short: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        day_names: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        day_names_short: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        date_suffix: function (date) {
            return (date === 1 ? 'er' : '');
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "gl": {
        month_names: "Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro".split("_"),
        month_names_short: "Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.".split("_"),
        day_names: "Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado".split("_"),
        day_names_short: "Dom._Lun._Mar._Mér._Xov._Ven._Sáb.".split("_"),
        date_suffix: function (date) {
            return 'º';
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "he": {
        month_names: "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),
        month_names_short: "ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),
        day_names: "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
        day_names_short: "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "hi": {
        month_names: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split("_"),
        month_names_short: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split("_"),
        day_names: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split("_"),
        day_names_short: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return "रात";
            } else if (hour < 10) {
                return "सुबह";
            } else if (hour < 17) {
                return "दोपहर";
            } else if (hour < 20) {
                return "शाम";
            } else {
                return "रात";
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "hr": {
        month_names: "sječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_"),
        month_names_short: "sje._vel._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
        day_names: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
        day_names_short: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
        date_suffix: function () {
            return '.';
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "hu": {
        month_names: "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),
        month_names_short: "jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),
        day_names: "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
        day_names_short: "vas_hét_kedd_sze_csüt_pén_szo".split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        date_suffix: function () {
            return '.';
        }
    },
    "hy-am": {
        month_names: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_'),
        month_names_short: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        day_names: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        day_names_short: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return "գիշերվա";
            } else if (hour < 12) {
                return "առավոտվա";
            } else if (hour < 17) {
                return "ցերեկվա";
            } else {
                return "երեկոյան";
            }
        }
    },
    "id": {
        month_names: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
        month_names_short: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des".split("_"),
        day_names: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
        day_names_short: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 11) {
                return 'pagi';
            } else if (hour < 15) {
                return 'siang';
            } else if (hour < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "is": {
        month_names: "janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),
        month_names_short: "jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),
        day_names: "sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),
        day_names_short: "sun_mán_þri_mið_fim_fös_lau".split("_"),
        date_suffix: function () {
            return '.';
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "it": {
        month_names: "Gennaio_Febbraio_Marzo_Aprile_Maggio_Giugno_Luglio_Agosto_Settembre_Ottobre_Novembre_Dicembre".split("_"),
        month_names_short: "Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic".split("_"),
        day_names: "Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato".split("_"),
        day_names_short: "Dom_Lun_Mar_Mer_Gio_Ven_Sab".split("_"),
        date_suffix: function () {
            return 'º';
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ja": {
        month_names: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        month_names_short: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        day_names: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),
        day_names_short: "日_月_火_水_木_金_土".split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return "午前";
            } else {
                return "午後";
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "ka": {
        month_names: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        month_names_short: "იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),
        day_names: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        day_names_short: "კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),
        date_suffix: function (date) {
            if (date === 0) {
                return "";
            }

            if (date === 1) {
                return "-ლი";
            }

            if ((date < 20) || (date <= 100 && (date % 20 === 0)) || (date % 100 === 0)) {
                return "მე-";
            }

            return "-ე";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "km": {
        month_names: "មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
        month_names_short: "មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
        day_names: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
        day_names_short: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ko": {
        month_names: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
        month_names_short: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
        day_names: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),
        day_names_short: "일_월_화_수_목_금_토".split("_"),
        date_suffix: function (date) {
            return "일";
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? '오전' : '오후';
        }
    },
    "lb": {
        month_names: "Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        month_names_short: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
        day_names: "Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
        day_names_short: "So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "lt": {
        month_names: "sausio_vasario_kovo_balandžio_gegužės_biržėlio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),
        month_names_short: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
        day_names: "pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis_sekmadienis".split("_"),
        day_names_short: "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
        date_suffix: function (date) {
            return "-oji";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "lv": {
        month_names: "janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),
        month_names_short: "jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),
        day_names: "svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),
        day_names_short: "Sv_P_O_T_C_Pk_S".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "mk": {
        month_names: "јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),
        month_names_short: "јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),
        day_names: "недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),
        day_names_short: "нед_пон_вто_сре_чет_пет_саб".split("_"),
        date_suffix: function (date) {
            var lastDigit = date % 10,
                last2Digits = date % 100;
            if (date === 0) {
                return '-ев';
            } else if (last2Digits === 0) {
                return '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return '-ти';
            } else if (lastDigit === 1) {
                return '-ви';
            } else if (lastDigit === 2) {
                return '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return '-ми';
            } else {
                return '-ти';
            }
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ml": {
        month_names: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split("_"),
        month_names_short: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split("_"),
        day_names: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split("_"),
        day_names_short: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return "രാത്രി";
            } else if (hour < 12) {
                return "രാവിലെ";
            } else if (hour < 17) {
                return "ഉച്ച കഴിഞ്ഞ്";
            } else if (hour < 20) {
                return "വൈകുന്നേരം";
            } else {
                return "രാത്രി";
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "mr": {
        month_names: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split("_"),
        month_names_short: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split("_"),
        day_names: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split("_"),
        day_names_short: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return "रात्री";
            } else if (hour < 10) {
                return "सकाळी";
            } else if (hour < 17) {
                return "दुपारी";
            } else if (hour < 20) {
                return "सायंकाळी";
            } else {
                return "रात्री";
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "ms-my": {
        month_names: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        month_names_short: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        day_names: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        day_names_short: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 11) {
                return 'pagi';
            } else if (hour < 15) {
                return 'tengahari';
            } else if (hour < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "nb": {
        month_names: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        month_names_short: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
        day_names: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
        day_names_short: "sø._ma._ti._on._to._fr._lø.".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ne": {
        month_names: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split("_"),
        month_names_short: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split("_"),
        day_names: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split("_"),
        day_names_short: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return "राती";
            } else if (hour < 10) {
                return "बिहान";
            } else if (hour < 15) {
                return "दिउँसो";
            } else if (hour < 18) {
                return "बेलुका";
            } else if (hour < 20) {
                return "साँझ";
            } else {
                return "राती";
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "nl": {
        month_names: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        month_names_short: "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
        day_names: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        day_names_short: "zo._ma._di._wo._do._vr._za.".split("_"),
        date_suffix: function (date) {
            return ((date === 1 || date === 8 || date >= 20) ? 'ste' : 'de');
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "nn": {
        month_names: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        month_names_short: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        day_names: "sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
        day_names_short: "sun_mån_tys_ons_tor_fre_lau".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "pl": {
        month_names: "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),
        month_names_short: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
        day_names: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),
        day_names_short: "nie_pon_wt_śr_czw_pt_sb".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "pt-br": {
        month_names: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        month_names_short: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        day_names: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),
        day_names_short: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
        date_suffix: function (date) {
            return "º";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "pt": {
        month_names: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        month_names_short: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        day_names: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),
        day_names_short: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
        date_suffix: function (date) {
            return "º";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ro": {
        month_names: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),
        month_names_short: "ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
        day_names: "duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),
        day_names_short: "Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ru": {
        month_names: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        month_names_short: 'янв_фев_мар_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        day_names: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        day_names_short: "вс_пн_вт_ср_чт_пт_сб".split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return "ночи";
            } else if (hour < 12) {
                return "утра";
            } else if (hour < 17) {
                return "дня";
            } else {
                return "вечера";
            }
        },
        date_suffix: function (date) {
            return '-го';
        }
    },
    "sk": {
        month_names: "január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),
        month_names_short: "jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_"),
        day_names: "nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),
        day_names_short: "ne_po_ut_st_št_pi_so".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "sl": {
        month_names: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
        month_names_short: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
        day_names: "nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),
        day_names_short: "ned._pon._tor._sre._čet._pet._sob.".split("_"),
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "sq": {
        month_names: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),
        month_names_short: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),
        day_names: "E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),
        day_names_short: "Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'PD' : 'MD';
        },
        date_suffix: function (date) {
            return ".";
        }
    },
    "sr-cyr": {
        month_names: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
        month_names_short: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
        day_names: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
        day_names_short: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "sr": {
        month_names: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
        month_names_short: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
        day_names: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
        day_names_short: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
        date_suffix: function (date) {
            return ".";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "sv": {
        month_names: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
        month_names_short: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        day_names: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),
        day_names_short: "sön_mån_tis_ons_tor_fre_lör".split("_"),
        date_suffix: function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                    (b === 1) ? 'a' :
                        (b === 2) ? 'a' :
                            (b === 3) ? 'e' : 'e';
            return output;
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "ta": {
        month_names: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split("_"),
        month_names_short: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split("_"),
        day_names: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split("_"),
        day_names_short: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split("_"),
        date_suffix: function (date) {
            return 'வது';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 6 && hour <= 10) {
                return " காலை";
            } else if (hour >= 10 && hour <= 14) {
                return " நண்பகல்";
            } else if (hour >= 14 && hour <= 18) {
                return " எற்பாடு";
            } else if (hour >= 18 && hour <= 20) {
                return " மாலை";
            } else if (hour >= 20 && hour <= 24) {
                return " இரவு";
            } else if (hour >= 0 && hour <= 6) {
                return " வைகறை";
            }
        }
    },
    "th": {
        month_names: "มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),
        month_names_short: "มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา".split("_"),
        day_names: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),
        day_names_short: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return "ก่อนเที่ยง";
            } else {
                return "หลังเที่ยง";
            }
        },
        date_suffix: function (date) {
            return "";
        }
    },
    "tl-ph": {
        month_names: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
        month_names_short: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
        day_names: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
        day_names_short: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
        date_suffix: function (number) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "tr": {
        month_names: "Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),
        month_names_short: "Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),
        day_names: "Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),
        day_names_short: "Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),
        date_suffix: function (number) {
            if (number === 0) { // special case for zero
                return number + "'ıncı";
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;

            return (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "tzm-la": {
        month_names: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
        month_names_short: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
        day_names: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        day_names_short: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "tzm": {
        month_names: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
        month_names_short: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
        day_names: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        day_names_short: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "uk": {
        month_names: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_'),
        month_names_short: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),
        day_names: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        day_names_short: "нд_пн_вт_ср_чт_пт_сб".split("_"),
        date_suffix: function (date) {
            return "-го";
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return "ночі";
            } else if (hour < 12) {
                return "ранку";
            } else if (hour < 17) {
                return "дня";
            } else {
                return "вечора";
            }
        }
    },
    "uz": {
        month_names: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),
        month_names_short: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
        day_names: "Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),
        day_names_short: "Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "vi": {
        month_names: "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),
        month_names_short: "Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),
        day_names: "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),
        day_names_short: "CN_T2_T3_T4_T5_T6_T7".split("_"),
        date_suffix: function (date) {
            return "";
        },
        meridiem: function (hour, minute, isLower) {
            return "";
        }
    },
    "zh-cn": {
        month_names: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        month_names_short: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        day_names: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        day_names_short: "周日_周一_周二_周三_周四_周五_周六".split("_"),
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return "凌晨";
            } else if (hm < 900) {
                return "早上";
            } else if (hm < 1130) {
                return "上午";
            } else if (hm < 1230) {
                return "中午";
            } else if (hm < 1800) {
                return "下午";
            } else {
                return "晚上";
            }
        },
        date_suffix: function (number, period) {
            return number + "日";

        }
    },
    "zh-tw": {
        month_names: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        month_names_short: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        day_names: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        day_names_short: "週日_週一_週二_週三_週四_週五_週六".split("_"),
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 900) {
                return "早上";
            } else if (hm < 1130) {
                return "上午";
            } else if (hm < 1230) {
                return "中午";
            } else if (hm < 1800) {
                return "下午";
            } else {
                return "晚上";
            }
        },
        date_suffix: function (number, period) {
            return number + "日";
        }

    }
};